import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main data-testid="page-not-found" className="flex min-h-[70vh] flex-col items-center justify-center px-6 pt-24 text-center">
      <p className="font-display text-7xl font-semibold text-lav">404</p>
      <h1 className="mt-4 font-display text-2xl font-semibold text-ink sm:text-3xl">
        This page wandered off.
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-ink-soft sm:text-base">
        Happens to the best of us. Take a breath, and head back to somewhere familiar.
      </p>
      <Link
        to="/"
        data-testid="notfound-link-home"
        className="mt-8 rounded-full bg-ink px-8 py-4 font-bold text-cream transition-colors duration-300 hover:bg-lav-deep"
      >
        Back home
      </Link>
    </main>
  );
}
